import { useEffect } from 'react'

import { TOPBAR_INTERNAL_DATA } from './constants'
import styles from './topbar.module.scss'
import { TopbarData } from './types'

export interface TopbarForCustomDocumentProps {
  [TOPBAR_INTERNAL_DATA]?: TopbarData | null
}

export function TopbarHead({ [TOPBAR_INTERNAL_DATA]: data }: TopbarForCustomDocumentProps) {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && data === null) {
      throw new Error(
        'Topbar was disabled in this page. Missing correct "withTopbarProps" call in custom document ' +
          'getInitialProps and page to have getServerSideProps to force SSR'
      )
    }
  }, [data])
  if (!data || data.disabled) {
    return null
  }
  return (
    <>
      <link rel="preload" as="script" href={data.js} />
      <link rel="preload" as="style" href={data.css} />
      {data.criticalCss && <style className="critical-css">{data.criticalCss}</style>}
    </>
  )
}

export function TopbarBody({ [TOPBAR_INTERNAL_DATA]: data }: TopbarForCustomDocumentProps) {
  if (!data || data.disabled) {
    return null
  }
  const lazyCssLink = `
    <link
      id="lazy-css-link"
      rel="stylesheet"
      href="${data.css}"
      media="not all"
      onload="__jbTopbarCSSOnload()"
    >
  `
    .replace(/\s+/g, ' ')
    .trim()
  return (
    <>
      <script
        id="lazy-css"
        dangerouslySetInnerHTML={{
          __html: `
            document.getElementById('lazy-css').insertAdjacentHTML('afterend', '${lazyCssLink}');

            function __jbTopbarCSSOnload() {
              // change media to all
              var linkTag = document.getElementById('lazy-css-link')
              if (linkTag) {
                linkTag.setAttribute('media', 'all');
                linkTag.removeAttribute('onload');
              }

              // remove critical css
              var elems = document.querySelectorAll('.critical-css');
              Array.prototype.forEach.call(elems, function (e) {
                e.parentElement.removeChild(e);
              });

              // remove handler
              window.__jbTopbarCSSOnload = undefined;
            }
          `,
        }}
      />
      <noscript>
        <link rel="stylesheet" href={data.css} />
      </noscript>
      <div className={styles['Topbar-container']} dangerouslySetInnerHTML={{ __html: data.html }} />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.topbarInitialState = ${JSON.stringify(data.topbarInitialState)} || {};`,
        }}
      />
      <script async src={data.js} />
    </>
  )
}
